import { createSelector } from '@reduxjs/toolkit';

const entityMenuItemsSequencer = (a, b) => {
  return (
    (b.entity.priority - a.entity.priority)
    || (a.entity.name.localeCompare(b.entity.name, 'en'))
    || (a.entity.globalPriority
      ? a.entity.globalPriority.localeCompare(b.entity.globalPriority)
      : 0)
  );
};

export const createEntityMenuItemsSelector = (...args) => {
  if (args.length === 2) {
    return createSelector(
      args[0], // entities selector
      (entities) => {
        return entities
          .valueSeq()
          .toArray()
          .map((entity) => args[1](entity)) // item factory
          .sort(entityMenuItemsSequencer);
      });
  }
  else if (args.length === 3) {
    return createSelector(
      args[0], // parents selector
      args[1], // entities selector
      (parents, entities) => {
        return entities
          .valueSeq()
          .toArray()
          .map((entity) => args[2](parents, entity)) // item factory
          .sort(entityMenuItemsSequencer);
      });
  }
};
